var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeft({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.707 4.29289C13.0975 4.68342 13.0975 5.31658 12.707 5.70711L8.41406 10L12.707 14.2929C13.0975 14.6834 13.0975 15.3166 12.707 15.7071C12.3164 16.0976 11.6833 16.0976 11.2927 15.7071L6.99985 11.4142C6.2188 10.6332 6.2188 9.36684 6.99985 8.58579L11.2927 4.29289C11.6833 3.90237 12.3164 3.90237 12.707 4.29289Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow-left.4d82a169d47a401bb7eb08fb586dee20.svg";
export { ForwardRef as ReactComponent };